const mineStatus = [
    'Construction',
    'Commissioning',
    'Production',
    'Decommissioning',
    'Closed'
]
export const hasMineOffice = status => {
    return mineStatus.includes(status);
}